import pickBy from "lodash-es/pickBy";
import { createSelector } from "reselect";

import { initialCommentEditState } from "@/mk2/apps/forum/containers/CommentEdit/CommentEdit.constants";
import { CommentEditState } from "@/mk2/apps/forum/containers/CommentEdit/CommentEdit.reducers";
import {
    ComplaintsStatistics,
    ComplaintsStatisticsPerPost,
    MyAnonymousPostEntity,
} from "@/mk2/apps/forum/schemas";
import { memoizeOne } from "@/mk2/helpers/cache";
import { AppState } from "@/mk2/reducers";

export const getMyAnonymousPostsIds = memoizeOne((myAnonymousPosts: MyAnonymousPostEntity[]) => {
    return myAnonymousPosts.filter((item) => item).map((item) => item.id);
});

export const getForumComplaintsStatisticsForTopic = createSelector(
    [
        (state: AppState, topicId: number) => state.containers.forum.shared.complaintsStatistics,
        (state: AppState, topicId: number) => topicId,
    ],
    (complaintsStatistics, topicId: number) => {
        if (!complaintsStatistics) {
            return {};
        }
        return pickBy<ComplaintsStatisticsPerPost>(
            complaintsStatistics,
            (element: ComplaintsStatistics) => {
                return element.topicId === topicId;
            },
        );
    },
);
